/*
 * Authors: mariushirjanu
 * Created: 21/11/2023
 */
import { NgForOf } from '@angular/common';
import { Directive, Host, Input, NgIterable } from '@angular/core';

/**
 * @description Allow to specify a custom property for ngFor trackBy
 * @example <div *ngFor="let faqCode of faqCodes; trackByProp: 'name'"></div>
 */

@Directive({
  selector: '[ngForTrackByProp]'
})
export class NgForTrackByPropDirective<T> {
  @Input() ngForOf:NgIterable<T>;
  @Input() set ngForTrackByProp(value:keyof T) {
    this.prop = value;
  }

  private prop:keyof T;

  constructor(@Host() public ngForOfDir:NgForOf<T>) {
    this.ngForOfDir.ngForTrackBy = this.trackBy.bind(this);
  }

  public trackBy(index:number, item:T) {
    if (!this.prop) {
      throw new Error('No prop specified for trackByProp');
    }

    // fallback to id or index when the prop is not found
    if (!item[this.prop]) {
      return item['id'] || index;
    }

    return this.prop && item[this.prop];
  }
}